import { UserV2 } from '@/user/entity/UserV2';
import { AccessGroup } from './AccessGroup';
import { Contact } from './Contact';
export class AccessEntryModel {
    type;
    id;
    // Contact in AccessEntry does not contain an id because, in addition to user address book contacts,
    // it may also represent an email address that was used in previous access grants.
    contact;
    accessGroup;
    issuer;
    createdAt;
    dataAccess;
    state;
    error;
}
export class AccessEntry extends AccessEntryModel {
    constructor(model) {
        super();
        Object.keys(model).forEach((key) => {
            switch (key) {
                case 'contact':
                    this.contact = model.contact ? new Contact(model.contact) : null;
                    break;
                case 'accessGroup':
                    this.accessGroup = model.accessGroup ? new AccessGroup(model.accessGroup) : null;
                    break;
                case 'issuer':
                    this.issuer = new UserV2(model.issuer);
                    break;
                default:
                    this[key] = model[key];
            }
        });
    }
    // added for backward compatibility
    get assignee() {
        return this.contact;
    }
    getTargetId() {
        return this.type === 'product' ? parseInt(this.id, 10) : this.id;
    }
}
